import type { ComponentType, SVGProps } from 'react';
import {
  Activity,
  BadgeCheck,
  Ban,
  Banknote,
  BarChart3,
  Building2,
  CreditCard,
  Factory,
  FileMinus,
  FileSearch,
  FileSignature,
  FileText,
  FileX,
  FolderDown,
  Globe,
  Handshake,
  HelpCircle,
  History,
  Image,
  KeyRound,
  LayoutDashboard,
  LayoutTemplate,
  Map,
  MapPin,
  MonitorSmartphone,
  PanelLeft,
  Percent,
  Printer,
  Receipt,
  Recycle,
  Scale,
  ScrollText,
  Settings,
  ShieldCheck,
  SlidersHorizontal,
  Sparkles,
  Tag,
  Upload,
  Users,
  UsersRound,
  Wallet,
  Wrench,
  Zap,
  CircleDot,
} from 'lucide-react';

type Componente = ComponentType<SVGProps<SVGSVGElement>>;

const ICONOS: Record<string, Componente> = {
  Activity,
  BadgeCheck,
  Ban,
  Banknote,
  BarChart3,
  Building2,
  CreditCard,
  Factory,
  FileMinus,
  FileSearch,
  FileSignature,
  FileText,
  FileX,
  FolderDown,
  Globe,
  Handshake,
  HelpCircle,
  History,
  Image,
  KeyRound,
  LayoutDashboard,
  LayoutTemplate,
  Map,
  MapPin,
  MonitorSmartphone,
  PanelLeft,
  Percent,
  Printer,
  Receipt,
  Recycle,
  Scale,
  ScrollText,
  Settings,
  ShieldCheck,
  SlidersHorizontal,
  Sparkles,
  Tag,
  Upload,
  Users,
  UsersRound,
  Wallet,
  Wrench,
  Zap,
};

export const ICONOS_DISPONIBLES = Object.keys(ICONOS).sort();

export function Icono({ nombre, className }: { nombre: string; className?: string }) {
  const Componente = ICONOS[nombre] ?? CircleDot;
  return <Componente className={className} aria-hidden />;
}
